import { WatchSVG } from '@sbercloud/uikit-product-icons';
import { WithLayoutType } from '@sbercloud/uikit-product-utils';
import { PromoTag } from '@snack-uikit/promo-tag';
import { Typography } from '@snack-uikit/typography';

import { DropdownShare } from '../../helperComponents';
import styles from './styles.module.scss';

type ArticleAuthor = {
  image: string;
  name: string;
  position: string;
};

type HeaderArticleProps = WithLayoutType<{
  articleTitle: string;
  tag: string;
  image: string;
  author?: ArticleAuthor;
  timeToRead: string;
  releaseDate: string;
}>;

export function HeaderArticle(props: HeaderArticleProps) {
  const {
    layoutType,
    articleTitle,
    tag,
    image,
    author,
    timeToRead,
    releaseDate,
  } = props;

  return (
    <div>
      <div className={styles.header}>
        <PromoTag
          appearance="neutral"
          size="s"
          text={tag}
          data-test-id="header-article-tag"
        />
        <DropdownShare />
      </div>
      <img
        className={styles.image}
        src={image}
        alt={`Иллюстрация для статьи на тему «${articleTitle}»`}
        data-layout-type={layoutType}
        data-test-id="header-article-image"
      />
      <div className={styles.footer} data-layout-type={layoutType}>
        <div
          className={styles.mobileItems}
          data-layout-type={layoutType}
          data-test-id="header-article-mobile-items"
        >
          <Typography.SansBodyL className={styles.footerItemDescription}>
            {releaseDate}
          </Typography.SansBodyL>
          <Typography.SansBodyL className={styles.footerItemDescription}>
            <WatchSVG />
            &nbsp;{timeToRead}
          </Typography.SansBodyL>
        </div>
        {author ? (
          <div className={styles.author} data-test-id="header-article-author">
            <img
              className={styles.authorImage}
              src={author.image}
              alt="Автор блога"
              data-layout-type={layoutType}
            />
            <div className={styles.authorInfo}>
              <Typography.SansTitleM className={styles.name}>
                {author.name}
              </Typography.SansTitleM>
              <Typography.SansBodyL className={styles.position}>
                {author.position}
              </Typography.SansBodyL>
            </div>
          </div>
        ) : null}
        <div
          className={styles.footerItemWrapper}
          data-layout-type={layoutType}
          data-test-id="header-article-time-to-read"
        >
          <div className={styles.divider} data-layout-type={layoutType} />
          <div className={styles.footerItem}>
            <Typography.SansTitleM className={styles.footerItemTitle}>
              Время чтения
            </Typography.SansTitleM>
            <Typography.SansBodyL className={styles.footerItemDescription}>
              {timeToRead}
            </Typography.SansBodyL>
          </div>
        </div>
        <div
          className={styles.footerItemWrapper}
          data-layout-type={layoutType}
          data-test-id="header-article-release-date"
        >
          <div className={styles.divider} data-layout-type={layoutType} />
          <div className={styles.footerItem}>
            <Typography.SansTitleM className={styles.footerItemTitle}>
              Дата публикации
            </Typography.SansTitleM>
            <Typography.SansBodyL className={styles.footerItemDescription}>
              {releaseDate}
            </Typography.SansBodyL>
          </div>
        </div>
      </div>
    </div>
  );
}
